import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/lib/contexts/AuthContext'
import { verifyNewEmail } from '@/lib/api/api'
import { SystemCardShell, SystemCardHeading, SystemCardProgress } from '@/components/shared/layout'

export default function ChangeEmail() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { token } = useAuth()

  useEffect(() => {
    const handleEmailChange = async () => {
      if (!token) {
        navigate('/sign-in')
        return
      }

      const changeEmailToken = searchParams.get('token')
      
      if (!changeEmailToken) {
        navigate('/user-settings')
        return
      }

      try {
        await verifyNewEmail(changeEmailToken, token)
        navigate('/user-settings?change_email=true')
      } catch (error) {
        console.error('Email verification failed:', error)
        navigate('/user-settings?change_email=error')
      }
    }

    handleEmailChange()
  }, [searchParams, navigate, token])

  return (
    <SystemCardShell>
      <SystemCardHeading eyebrow="Account" title="Confirming your new email">
        You'll land on your account settings in a moment.
      </SystemCardHeading>
      <SystemCardProgress label="Confirming" />
    </SystemCardShell>
  )
}
